import objectAssign from 'object-assign'
import vuxLocales from './View'
import componentsLocales from './vux'

// yaml语法教程 http://www.ruanyifeng.com/blog/2016/07/yaml.html?f=tt
const finalLocales = {
  'en-US': objectAssign(vuxLocales['en-US'], componentsLocales['en-US']),
  'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'])
}
export default finalLocales
